import type { PhoneCountryConfig } from "@zaprooecommerce/storefront-ui-vue";
import { sortBy } from "lodash-es";
import { phoneCodesMap } from "./variables";
import { PHONE_CONFIG } from "~/composables/usePhoneConfig/variables/PhoneConfig";

export function usePhoneConfig() {
  const { store } = useI18nExtend();

  const actualCountryCodes = ref<string[]>(
    store.value.locales.map((locale) => phoneCodesMap[locale]),
  );
  const config = ref<PhoneCountryConfig[]>(
    sortBy(
      PHONE_CONFIG,
      (code: PhoneCountryConfig) =>
        !actualCountryCodes.value.includes(code.country),
    ) as PhoneCountryConfig[],
  );

  return {
    config,
  };
}
